var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',_vm._g({staticClass:"mt-2",attrs:{"color":"teal darken-1","dark":"","small":""},on:{"click":_vm.handleClickRow}},_vm.on),[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" mdi-eye ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }